export const AvailableLanguages = ({languages = []}) => (
  <div className="available-languages">{languages.join(", ")}</div>
);
